<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    role="img"
    :aria-label="ariaLabel"
    :width="svgWidth"
    :height="svgHeight"
    preserveAspectRatio="xMidYMid meet"
    class="solvit-logo-white-full"
  >
    <!--
      solvit_logo_white.png: y=330 기준 심볼/워드마크 분리 → 각각 이진화·potrace 후 500×500에 배치.
      fill은 currentColor (부모 color로 테마 연동).
    -->
    <svg
      x="121"
      y="29"
      width="235"
      height="278"
      viewBox="0 0 169 200"
      preserveAspectRatio="xMidYMid meet"
      overflow="visible"
    >
      <g transform="translate(0,200) scale(0.1,-0.1)" fill="currentColor">
        <path
          d="M605 1974 c-117 -28 -168 -46 -270 -96 -101 -50 -215 -124 -215 -140 0 -4 -5 -8 -11 -8 -18 0 -99 -90 -99 -110 0 -39 50 -24 110 33 63 60 124 107 139 107 6 0 11 4 11 8 0 8 101 62 116 62 4 0 15 6 23 13 20 16 161 61 258 82 149 31 322 17 513 -42 47 -15 92 -33 101 -40 8 -7 19 -13 23 -13 15 0 116 -54 116 -62 0 -4 5 -8 11 -8 14 0 73 -45 139 -107 60 -57 110 -72 110 -33 0 20 -81 110 -99 110 -6 0 -11 4 -11 8 0 8 -21 23 -140 102 -75 49 -214 103 -352 134 -88 21 -386 20 -473 0z"
        />
        <path
          d="M676 1633 c-3 -4 -26 -6 -49 -4 -31 1 -51 -4 -69 -19 -15 -11 -33 -20 -42 -20 -9 0 -30 -13 -47 -29 -17 -17 -34 -31 -38 -33 -19 -8 -83 -114 -88 -147 -4 -20 -10 -38 -14 -41 -12 -8 -23 -110 -12 -110 6 0 9 -24 7 -57 -4 -62 10 -113 31 -113 7 0 10 -9 8 -24 -4 -17 4 -33 26 -55 17 -17 31 -36 31 -41 0 -6 3 -10 8 -10 4 0 25 -16 46 -35 22 -19 54 -38 73 -41 18 -3 33 -11 33 -16 0 -6 18 -8 40 -6 22 2 40 0 40 -4 0 -5 22 -8 49 -8 39 0 51 4 54 18 4 16 5 16 6 0 1 -15 10 -18 51 -18 33 0 50 4 50 13 0 8 2 9 8 1 4 -6 33 -13 65 -16 93 -8 137 -63 105 -133 -24 -53 -39 -55 -391 -55 l-324 0 -7 -38 c-10 -63 -7 -91 14 -112 11 -11 20 -26 20 -33 0 -21 44 -57 68 -57 12 0 22 -4 22 -9 0 -5 9 -12 19 -16 10 -3 21 -14 24 -24 7 -28 75 -34 353 -29 233 4 294 12 294 40 0 4 8 8 18 8 19 0 101 55 115 77 4 6 15 20 24 29 22 21 43 62 43 81 0 8 7 21 15 29 21 22 26 270 6 284 -4 3 -11 18 -15 34 -13 55 -87 146 -118 146 -10 0 -18 5 -18 11 0 17 -27 39 -48 39 -11 0 -22 6 -25 14 -9 22 -120 36 -283 36 -96 0 -159 4 -175 12 -51 24 -61 99 -19 136 11 9 20 22 20 29 0 8 13 13 33 13 18 0 38 5 43 10 8 8 15 6 24 -5 7 -8 25 -15 40 -15 15 0 33 7 40 15 9 11 16 13 24 5 13 -13 62 -13 87 0 11 6 19 7 19 1 0 -16 32 -22 67 -10 18 6 33 15 33 20 0 5 11 9 25 9 61 0 155 141 155 233 l0 49 -32 -6 c-18 -3 -39 -6 -45 -6 -14 1 -76 2 -95 1 -7 0 -32 2 -54 5 -24 3 -44 2 -48 -4 -4 -7 -16 -6 -36 1 -22 8 -38 8 -60 0 -17 -7 -32 -7 -36 -2 -7 12 -81 12 -89 -1 -4 -7 -12 -7 -25 0 -21 11 -63 13 -74 3z"
        />
        <path
          d="M60 290 c0 -11 7 -20 15 -20 8 0 15 -4 15 -8 0 -20 224 -144 335 -185 243 -90 597 -90 840 0 100 37 282 135 328 177 9 9 22 16 27 16 6 0 10 9 10 20 0 17 -7 20 -40 20 -22 0 -40 -4 -40 -10 0 -5 -5 -10 -12 -10 -6 0 -25 -11 -42 -24 -145 -109 -449 -206 -651 -206 -202 0 -506 97 -651 206 -17 13 -36 24 -42 24 -7 0 -12 5 -12 10 0 6 -18 10 -40 10 -33 0 -40 -3 -40 -20z"
        />
      </g>
    </svg>
    <svg
      x="27"
      y="348"
      width="446"
      height="121"
      viewBox="0 0 446 121"
      preserveAspectRatio="xMidYMid meet"
      overflow="visible"
    >
      <g transform="translate(0,121) scale(0.1,-0.1)" fill="currentColor">
        <path
          d="M209 1167 c-166 -47 -204 -202 -68 -273 15 -7 75 -25 133 -39 165 -39 196 -59 196 -130 0 -90 -180 -130 -348 -77 l-62 20 -16 -29 c-14 -28 -14 -30 12 -39 57 -22 123 -32 214 -33 122 -1 194 20 257 78 42 37 46 46 50 95 8 95 -52 140 -232 179 -118 26 -167 48 -179 84 -34 96 144 150 303 93 41 -15 46 -15 63 0 10 10 18 23 18 30 0 36 -250 67 -341 41z"
        />
        <path
          d="M1104 1160 c-185 -60 -263 -298 -153 -464 74 -111 256 -159 419 -110 156 46 237 257 163 424 -61 139 -256 207 -429 150z m243 -62 c143 -67 150 -370 11 -453 -77 -45 -233 -28 -291 33 -65 68 -85 239 -38 335 50 104 195 142 318 85z"
        />
        <path
          d="M1920 876 l0 -294 198 -4 c108 -2 198 -4 199 -3 2 1 5 15 9 31 l6 29 -162 -4 -161 -3 3 271 3 271 -47 0 -48 0 0 -294z"
        />
        <path
          d="M2480 1165 c0 -3 15 -36 34 -73 18 -37 79 -169 136 -294 l103 -228 47 0 46 0 118 258 c65 141 129 276 143 300 l24 42 -53 0 -53 0 -82 -188 c-45 -103 -94 -217 -109 -254 -14 -38 -27 -68 -28 -68 -2 0 -52 115 -112 255 l-109 255 -52 0 c-29 0 -53 -2 -53 -5z"
        />
        <path
          d="M3455 875 l0 -295 50 0 50 0 0 295 0 295 -50 0 -50 0 0 -295z"
        />
        <path
          d="M3900 1140 l0 -30 105 0 105 0 0 -265 0 -265 50 0 50 0 0 265 0 265 104 0 c85 0 105 3 110 16 17 45 21 44 -259 44 l-265 0 0 -30z"
        />
        <path
          d="M1074 317 c-11 -29 1 -280 14 -285 9 -3 12 13 12 56 l0 60 56 7 c91 11 133 77 87 134 -29 35 -158 56 -169 28z m138 -34 c47 -43 7 -103 -69 -103 l-43 0 0 60 0 60 47 0 c29 0 53 -6 65 -17z"
        />
        <path
          d="M1400 180 l0 -151 78 3 c95 4 102 22 10 26 l-68 3 0 134 c0 83 -4 135 -10 135 -6 0 -10 -57 -10 -150z"
        />
        <path
          d="M1745 318 c-60 -172 -95 -274 -95 -281 0 -24 27 5 41 44 17 44 17 44 71 47 l54 3 15 -47 c15 -48 39 -72 39 -37 -1 10 -22 76 -48 147 -44 121 -66 156 -77 124z m22 -166 c-52 -4 -52 -3 -27 74 l23 67 21 -69 22 -69 -39 -3z"
        />
        <path
          d="M1950 315 c0 -11 11 -15 45 -15 l45 0 0 -136 c0 -104 3 -135 13 -132 8 3 13 42 15 136 l3 132 45 0 c32 0 44 4 42 13 -7 20 -208 23 -208 2z"
        />
        <path
          d="M2290 179 c0 -116 3 -150 13 -147 7 3 13 29 15 71 l3 67 54 0 c30 0 55 5 55 10 0 6 -25 10 -55 10 l-55 0 0 55 0 55 65 0 c51 0 65 3 65 15 0 12 -16 15 -80 15 l-80 0 0 -151z"
        />
        <path
          d="M2604 297 c-35 -32 -38 -39 -42 -99 -7 -108 37 -168 121 -168 89 0 146 123 103 223 -19 46 -49 69 -99 74 -40 5 -48 2 -83 -30z m137 -23 c33 -35 35 -149 4 -184 -45 -50 -112 -45 -140 11 -29 55 -12 177 27 192 36 15 85 6 109 -19z"
        />
        <path
          d="M2945 318 c-12 -30 0 -281 13 -286 9 -3 12 14 12 62 l0 66 29 0 c25 0 34 -9 67 -65 21 -36 44 -65 51 -65 19 0 17 6 -22 70 -39 64 -41 70 -22 70 46 0 70 85 35 123 -28 33 -153 52 -163 25z m137 -35 c44 -39 8 -93 -63 -93 l-49 0 0 55 0 55 47 0 c29 0 53 -6 65 -17z"
        />
        <path
          d="M3264 317 c-9 -24 1 -282 11 -282 6 0 12 48 15 114 l5 113 36 -98 c19 -54 40 -99 46 -101 6 -2 25 36 42 84 50 140 50 140 50 6 1 -75 5 -123 11 -123 6 0 10 57 10 150 0 122 -3 150 -14 150 -15 0 -17 -4 -51 -100 -49 -141 -42 -138 -84 -25 -20 55 -40 106 -45 113 -9 16 -25 15 -32 -1z"
        />
      </g>
    </svg>
  </svg>
</template>

<script>
export default {
  name: 'SolvitLogoWhiteFull',
  props: {
    /** 표시 높이(px). viewBox 정사각형이므로 기본적으로 너비도 동일. */
    size: {
      type: [Number, String],
      default: 120
    },
    /** 너비(px). 지정 시 높이와 독립적으로 스케일(비권장: 왜곡 가능). 미지정 시 size와 동일. */
    width: {
      type: [Number, String],
      default: null
    },
    ariaLabel: {
      type: String,
      default: 'Solvit'
    }
  },
  computed: {
    svgHeight() {
      return Number(this.size);
    },
    svgWidth() {
      return this.width != null && this.width !== '' ? Number(this.width) : Number(this.size);
    }
  }
};
</script>
